import React, { useRef, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { Button, Grid, Table, Header } from "semantic-ui-react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import { BaseUrlInvoice } from "../formcomponents/Constants";

const TourInvoicepdf = () => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "INVOICE",
    onAfterPrint: () => alert("print SUCCESS"),
  });
  const { id } = useParams();
  const [invoiceData, setInvoiceData] = useState();

  const [hotelList, setHotelList] = useState([]);

  const [tourItemList, setTourItemLIst] = useState([]);
  useEffect(() => {
    console.log("id", id);

    getHotelList();
  }, [id]);

  const getTourInvoiceDetails = async () => {
    console.log("ididididi", id);
    await axios
      .post(BaseUrlInvoice + "accounts/getTourInvoiceDetails", {
        ssTourInvoiceId: id,
      })
      .then((res) => {
        console.log("accounts/getTourInvoiceDetails", res.data);

        setInvoiceData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getHotelList = async () => {
    axios
      .post(BaseUrlInvoice + "accounts/listSSCategory", {
        categoryType: 568,
      })
      .then((res) => {
        console.log("res", res.data);
        const hotelName = res.data.map((item) => ({
          text: item.categoryName,
          value: item.categoryId,
        }));
        setHotelList(hotelName);
        getAttractionList();
      });
  };

  const getAttractionList = async () => {
    axios
      .post(BaseUrlInvoice + "accounts/listSSCategory", {
        categoryType: 578,
      })
      .then((res) => {
        console.log("res", res.data);
        const tourItems = res.data.map((item) => ({
          text: item.categoryName,
          value: item.categoryId,
        }));
        setTourItemLIst(tourItems);
        getTourInvoiceDetails();
      });
  };

  const getItemName = (id) => {
    const itemData = tourItemList?.find((item) => item.value == id);

    return itemData ? itemData.text : null;
  };


  const getHotelName = (id) => {
    const hotelData = hotelList?.find((item) => item.value == id);

    return hotelData ? hotelData.text : null;
  };
  const rowStyle = {
    borderBottom: "none", // Remove bottom border for each row
  };
  const stylesForPrint = `
  @media print {
    @page {
      margin: 10mm; /* Set margins */
    }
    body {
      margin: 0; /* Reset body margins */
    }
    .page-break {
      page-break-after: always; /* Ensure content breaks into a new page */
      margin-bottom: 50px; /* Set bottom space */
    }
  }
`;

  const totalAmount = invoiceData?.itemList?.reduce(
    (total, item) => total + (item?.amount || 0),
    0
  );
  return (
    <>
      <div
        style={{
          padding: 10,
          marginBottom: 35,
        }}
      >
        <Button floated="right" onClick={handlePrint}>
          print
        </Button>
      </div>

      <div style={{ minHeight: "100vh", position: "relative" }}>
        <div style={{ paddingBottom: "50px" }}>
          <div
            ref={componentRef}
            style={{
              width: "100%",
              height: window.innerHeight,
              padding: 30,
              marginBottom: 35,
            }}
          >
            <style>{stylesForPrint}</style>
            <Grid>
              <Grid.Column width={5} floated="left">
                <Header as="h3">
                  PARMAR GROUP <br />
                  <Header.Subheader as="span">SILVER STAR</Header.Subheader>
                </Header>
              </Grid.Column>
              <Grid.Column width={7}>
                <Header as="h3" textAlign="right">
                  TOUR INVOICE
                </Header>
                <Table style={{ border: "none" }}>
                  <Table.Body>
                    <Table.Row className="noBottomBorder">
                      <Table.Cell textAlign="left">Date</Table.Cell>
                      <Table.Cell textAlign="right">
                        {invoiceData?.invoiceDate}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row className="noBottomBorder">
                      <Table.Cell textAlign="left">Customer Name</Table.Cell>
                      <Table.Cell textAlign="right">
                        {invoiceData?.invoiceName}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row className="noBottomBorder">
                      <Table.Cell textAlign="left">Mobile</Table.Cell>
                      <Table.Cell textAlign="right">
                        {invoiceData?.customerContact}
                      </Table.Cell>
                    </Table.Row>

                    <Table.Row className="noBottomBorder">
                      <Table.Cell textAlign="left">Invoice NO</Table.Cell>
                      <Table.Cell textAlign="right">
                        {invoiceData?.invoiceNumber}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row className="noBottomBorder">
                      <Table.Cell textAlign="left">Driver Name</Table.Cell>
                      <Table.Cell textAlign="right">
                        {invoiceData?.driverName}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row className="noBottomBorder">
                      <Table.Cell textAlign="left">Driver No </Table.Cell>
                      <Table.Cell textAlign="right">
                        {invoiceData?.driverNumber}
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Grid.Column>
            </Grid>
            <div className="page-break">
              <Table>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell
                      width={2}
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Date
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Item Name
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Customer Name
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Contact
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Reference
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Qunatity
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Unit Price
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Currency
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Total
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {invoiceData?.itemList?.map((item, index) => (
                    <Table.Row key={index}>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item.itemDate
                          ? new Date(item.itemDate).toLocaleDateString()
                          : null}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {getItemName(item?.tourItem)}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.custName}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.custNumber}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.reference}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.quantity}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.unitPrice}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.currency}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.amount}
                      </Table.Cell>
                    </Table.Row>
                  ))}
                  {/* {dataObject?.rowData?.map((item, index) => (
                    <Table.Row>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.itemName}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.itemDescription}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.itemQty}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.unitPrice}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.taxRate}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.disPer}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.amount}
                      </Table.Cell>
                    </Table.Row>
                  ))} */}
                  <Table.Row>
                    <Table.Cell
                      style={{
                        padding: "5px",
                      }}
                    ></Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}></Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}></Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}></Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}></Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}></Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}></Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}>
                      <b>
                        <h3>Total</h3>
                      </b>
                    </Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}>
                      {" "}
                      <b>{totalAmount}</b>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
              {/* <div
                style={{
                  backgroundColor: "#f0f0f0",
                  width: "100%",
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  textAlign: "center",
                  padding: "10px",
                  
                }}
              >
              
                <h4> Thank you for your business</h4>
                <div></div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// style={{ padding: "10px" }}

export default TourInvoicepdf;
